import { ShimBackgroundTypeV2 } from '@volkswagen-onehub/layer-manager';
import React, { useContext } from 'react';
import { NovedadesLayerContent } from '../components/novedades-layer-content';
import { useNovedadesCardClick } from './use-novedades-card-click';
import { useNovedadesTracker } from '../helpers/use-novedades-tracker';
import { NovedadesItem } from '@esportal/portal-service';
import { IContextNovedades } from '../models/context-novedades';

interface UseNovedadesLayerProps {
	item: NovedadesItem;
	context: React.Context<IContextNovedades>;
}

export const useNovedadesLayer = ({ item, context }: UseNovedadesLayerProps) => {
	const itemId = item.layer.title ?? item.id;
	const itemCtaLabel = item.card.cta.label ?? 'Descubre más';

	const { layerManager } = useContext(context);
	const { trackOpenLayerClick, trackLayerLoad, trackLayerCloseClick } = useNovedadesTracker({
		itemId: itemId.toString(),
	});

	const [isLayerOpen, setIsLayerOpen] = React.useState(false);
	const layerRef = React.useRef<any>(null);

	const handleOnClick = useNovedadesCardClick({ item, context });

	const handleLayerOpen = () => {
		trackOpenLayerClick(itemCtaLabel);
		setIsLayerOpen(true);
	};

	React.useEffect(() => {
		if (isLayerOpen) {
			trackLayerLoad();
		}
	}, [isLayerOpen, trackLayerLoad]);

	const handleLayerClose = () => {
		setIsLayerOpen(false);

		if (layerRef.current) {
			layerRef.current.close();
		}

		trackLayerCloseClick();
	};

	React.useEffect(() => {
		if (!isLayerOpen) return;

		const layer = layerManager.openContentLayerV2(
			() => <NovedadesLayerContent item={item} onCtaClick={handleOnClick} />,
			{},
			{
				shimBackgroundType: ShimBackgroundTypeV2.OPAQUE,
				closeButtonLabel: 'Close Video Layer',
				contentHeadline: item.card.title ?? '',
				onClose: handleLayerClose,
			},
		);

		layerRef.current = layer;

		return () => {
			layer.close();
			layerRef.current = null;
		};
	}, [isLayerOpen, layerManager]);

	return {
		handleLayerOpen,
		// retornar isLayerOpen, handleLayerClose si es necesario también
	};
};
